import { useEffect, useState } from "react";
import { getAllIssueClassifications } from "../services/reasonService";

const useFetchAllClassifications = ({
  setIsLoading,
}: {
  setIsLoading?: (loading: boolean) => void;
}) => {
  const [classificationsData, setClassificationsData] = useState<any[]>([]);

  useEffect(() => {
    const fetchClassifications = async () => {
      try {
        if (setIsLoading) setIsLoading(true);
        const result = await getAllIssueClassifications();
        setClassificationsData(result || []);
      } catch (error) {
        console.error("Error fetching all classifications:", error);
        setClassificationsData([]);
      } finally {
        if (setIsLoading) setIsLoading(false);
      }
    };

    fetchClassifications();
  }, []);

  return [classificationsData];
};

export default useFetchAllClassifications;

